// extracted by mini-css-extract-plugin
export var orderSummary = "_pr-0";
export var showMoreLessButton = "_pr-1";